module.exports = __webpack_public_path__ + "static/media/infinity.12af3290.svg";